import { ITailingIconTableCell } from '@aca-new/app/pages/payments/shared/components/tailing-icon-table-cell/interface/tailing-icon-table-cell.interface';
import { ICustomizedTableCellComponent } from '@aca-new/app/shared/components/table/shared/components/customized-table-cell/shared/interfaces/customized-table-cell.interface';
import { TableModule } from '@aca-new/app/shared/components/table/table.module';
import { IMyWindow } from '@aca-new/app/shared/interfaces/my-window.interface';
import { QimaColorService } from '@aca-new/app/shared/services/exported-services/qima-color/qima-color.service';
import { QimaIconService } from '@aca-new/app/shared/services/exported-services/qima-icon/qima-icon.service';
import { QimaTooltipService } from '@aca-new/app/shared/services/exported-services/qima-tooltip/qima-tooltip.service';
import { WINDOW } from '@aca-new/app/shared/tokens/window.token';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaAutoTooltipDirectiveModule, QimaIconModule, QimaTooltipDirectiveModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-tailing-icon-table-cell',
  templateUrl: './tailing-icon-table-cell.component.html',
  styleUrls: ['./tailing-icon-table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, QimaIconModule, QimaTooltipDirectiveModule, QimaAutoTooltipDirectiveModule, TranslateModule],
  standalone: true,
})
export class TailingIconTableCellComponent implements ICustomizedTableCellComponent {
  public data: ITailingIconTableCell = {};

  public constructor(
    @Inject(WINDOW) protected readonly _window: IMyWindow,
    public readonly qimaTooltip: QimaTooltipService,
    public readonly qimaIcon: QimaIconService,
    public readonly qimaColor: QimaColorService
  ) {}
}
